export const PROPERTY_CATEGORIES = {
  residential: {
    label: "Residential",
    types: [
      "house",
      "flat-and-apartments",
      "mini-flats",
      "self-contain",
      "terraces",
      "detached-bungalows",
      "semi-detached-duplex",
      "fully-detached-duplex",
      "penthouse",
      "maisonette",
      "block-of-flats",
    ],
    fields: [
      "bedroom_count",
      "bathroom_count",
      "property_size_sqm",
      "number_of_floors",
      "parking_spaces",
      "newly_built",
      "furnished",
      "serviced",
      "shared",
    ],
    amenities: [
      "balcony",
      "boys_quarters",
      "swimming_pool",
      "gym",
      "elevator",
      "security",
      "cctv",
      "fibre_internet",
      "generator",
      "solar_power",
      "borehole",
      "water_supply",
    ],
  },
  commercial: {
    label: "Commercial",
    types: [
      "office-spaces",
      "co-working-space",
      "shops",
      "shop-in-a-mall",
      "commercial-properties",
      "plaza",
      "retail-space",
      "showroom",
      "restaurant-cafe",
      "hotel-guest-house",
      "event-centre",
    ],
    fields: {
      "office-spaces": [
        "floor_area_sqm",
        "floor_number",
        "number_of_private_offices",
        "meeting_rooms",
        "conference_rooms",
        "reception_area",
        "open_workspace_capacity",
        "parking_capacity",
      ],
      "co-working-space": [
        "dedicated_desks",
        "private_offices",
        "meeting_rooms",
        "capacity",
        "internet_speed",
        "printing_available",
        "reception",
        "kitchen",
        "lounge",
      ],
      shops: [
        "shop_size_sqm",
        "floor_number",
        "storage_room",
        "parking",
        "electricity",
        "water_supply",
      ],
      "shop-in-a-mall": [
        "mall_name",
        "floor_level",
        "nearest_entrance",
        "operating_hours",
        "shop_size_sqm",
        "floor_number",
        "storage_room",
        "parking",
        "electricity",
        "water_supply",
        "central_air_conditioning",
        "escalator",
        "backup_generator",
        "cctv",
        "security",
        "fire_alarm_system",
        "emergency_exit",
        "public_toilets",
      ],
      "commercial-properties": [
        "total_floors",
        "total_units",
        "gross_floor_area",
        "parking_capacity",
        "elevator",
        "reception",
        "occupancy_status",
        "current_rental_income",
        "mixed_use",
      ],
      plaza: [
        "plaza_name",
        "total_floors",
        "number_of_units",
        "gross_floor_area",
        "available_unit_sizes",
        "number_of_vacant_units",
        "mixed_use",
      ],
      "retail-space": [
        "shop_area_sqm",
        "floor_level",
        "frontage_width",
        "ceiling_height",
        "display_window",
        "storage_room",
        "changing_room",
      ],
      showroom: [
        "display_area_sqm",
        "office_area",
        "storage_area",
        "ceiling_height",
        "glass_frontage_length",
        "number_of_floors",
      ],
      "restaurant-cafe": [
        "dining_capacity",
        "kitchen_size",
        "indoor_seating",
        "outdoor_seating",
        "number_of_restrooms",
        "private_dining_rooms",
        "bar_area",
      ],
      "hotel-guest-house": [
        "number_of_rooms",
        "room_types",
        "number_of_suites",
        "total_floors",
        "conference_rooms",
        "banquet_hall",
        "reception_area",
      ],
      "event-centre": [
        "hall_capacity",
        "number_of_event_halls",
        "vip_lounge",
        "bridal_room",
        "waiting_lounge",
        "kitchen",
        "dressing_room",
        "number_of_toilets",
      ],
    },
    amenities: [
      "elevator",
      "power_backup",
      "fibre_internet",
      "air_conditioning",
      "security",
      "access_control",
      "visitor_parking",
      "backup_generator",
      "cctv",
      "fire_extinguishers",
      "emergency_exit",
      "parking",
    ],
  },
  industrial: {
    label: "Industrial",
    types: ["warehouses", "factory", "workshop", "cold-room", "logistics-hub"],
    fields: {
      warehouses: [
        "warehouse_size",
        "ceiling_height",
        "loading_bays",
        "dock_levelers",
        "truck_access",
        "container_access",
        "office_attached",
        "parking_capacity",
        "cold_storage",
        "fire_safety_system",
      ],
      factory: [
        "factory_floor_area",
        "office_area",
        "warehouse_area",
        "number_of_production_floors",
        "ceiling_height",
        "floor_load_capacity",
        "loading_bays",
        "dock_doors",
      ],
      workshop: [
        "workshop_area",
        "office_area",
        "yard_space",
        "ceiling_height",
        "floor_strength",
      ],
      "cold-room": [
        "cold_storage_capacity",
        "number_of_cold_rooms",
        "temperature_range",
        "freezer_capacity",
        "chiller_capacity",
        "loading_area",
      ],
      "logistics-hub": [
        "warehouse_area",
        "yard_size",
        "office_area",
        "number_of_dock_doors",
        "truck_parking_capacity",
        "trailer_parking_capacity",
        "loading_bays",
      ],
    },
    amenities: [
      "cctv",
      "security",
      "truck_turning_area",
      "trailer_parking",
      "water_supply",
      "backup_generator",
      "weighbridge",
      "loading_ramp",
      "forklift_access",
      "dock_shelters",
      "fire_sprinkler_system",
      "smoke_detectors",
      "waste_disposal_area",
    ],
  },
  special_purpose: {
    label: "Special Purpose",
    types: [
      "school",
      "hospital",
      "church",
      "mosque",
      "filling_station",
      "petrol-gas-plant",
      "farm",
      "government-property",
    ],
    fields: {
      school: [
        "number_of_classrooms",
        "student_capacity",
        "labs",
        "library",
        "sports_facilities",
      ],
      hospital: [
        "number_of_beds",
        "number_of_wards",
        "operating_theatres",
        "emergency_unit",
        "pharmacy",
      ],
      church: ["seating_capacity", "parking_capacity", "stage"],
      mosque: ["seating_capacity", "parking_capacity", "ablution_area"],
      filling_station: [
        "number_of_pumps",
        "storage_tank_capacity",
        "convenience_store",
        "car_wash",
      ],
      "petrol-gas-plant": [
        "storage_tank_capacity",
        "number_of_pumps",
        "office_space",
        "security",
      ],
      farm: [
        "farm_size_hectares",
        "type_of_farming",
        "irrigation_system",
        "storage_facility",
      ],
      "government-property": [
        "building_type",
        "number_of_floors",
        "total_area",
        "security_level",
      ],
    },
    amenities: [],
  },
};

export const PROPERTY_TYPE_LABELS: Record<string, string> = {
  house: "House",
  "flat-and-apartments": "Flat / Apartment",
  "mini-flats": "Mini Flat",
  "self-contain": "Self Contain",
  terraces: "Terrace",
  "detached-bungalows": "Detached Bungalow",
  "semi-detached-duplex": "Semi-detached Duplex",
  "fully-detached-duplex": "Fully-detached Duplex",
  penthouse: "Penthouse",
  maisonette: "Maisonette",
  "block-of-flats": "Block of Flats",
  "office-spaces": "Office Space",
  "co-working-space": "Co-working Space",
  shops: "Shop",
  "shop-in-a-mall": "Shop in Mall",
  "commercial-properties": "Commercial Building",
  plaza: "Plaza",
  "retail-space": "Retail Space",
  showroom: "Showroom",
  "restaurant-cafe": "Restaurant / Café",
  "hotel-guest-house": "Hotel / Guest House",
  "event-centre": "Event Centre",
  warehouses: "Warehouse",
  factory: "Factory",
  workshop: "Workshop",
  "cold-room": "Cold Room",
  "logistics-hub": "Logistics Hub",
  school: "School",
  hospital: "Hospital",
  church: "Church",
  mosque: "Mosque",
  "filling-station": "Filling Station",
  "petrol-gas-plant": "Petrol / Gas Plant",
  farm: "Farm",
  "government-property": "Government Property",
};

export const PROPERTY_CATEGORY_LABELS: Record<string, string> = {
  residential: "Residential",
  commercial: "Commercial",
  industrial: "Industrial",
  "special-purpose": "Special Purpose",
};

export function getPropertyTypesByCategory(category: string): string[] {
  return (
    PROPERTY_CATEGORIES[category as keyof typeof PROPERTY_CATEGORIES]?.types ||
    []
  );
}

export function getFieldsByCategoryAndType(
  category: string,
  propertyType: string,
): string[] {
  const cat = PROPERTY_CATEGORIES[category as keyof typeof PROPERTY_CATEGORIES];
  if (!cat) return [];
  if (Array.isArray(cat.fields)) return cat.fields as string[];
  return (cat.fields as Record<string, string[]>)[propertyType] || [];
}

export function getAmenitiesByCategory(category: string): string[] {
  return (
    PROPERTY_CATEGORIES[category as keyof typeof PROPERTY_CATEGORIES]
      ?.amenities || []
  );
}

export function getPropertyTypeLabel(value: string): string {
  return PROPERTY_TYPE_LABELS[value] || value;
}

export function getPropertyCategoryLabel(value: string): string {
  return PROPERTY_CATEGORY_LABELS[value] || value;
}

export const PROPERTY_TYPE_OPTIONS = Object.entries(PROPERTY_TYPE_LABELS).map(
  ([value, label]) => ({ value, label }),
);

export function getPropertyTypeValueByLabel(label: string): string {
  const entry = Object.entries(PROPERTY_TYPE_LABELS).find(
    ([_, l]) => l === label,
  );
  return entry?.[0] || label;
}
